import { initialState } from '../state';
import { CurationInfoForPathwaysActions, CurationInfoForPathwaysActionTypes } from '../actions';
import { CurationItemId } from '@ispm-client/modules/pathways';

export function curationItemId(state = initialState.curationItemId, action: CurationInfoForPathwaysActions): CurationItemId {
  switch (action.type) {
    case CurationInfoForPathwaysActionTypes.UPDATE_CURATION_ITEM_ID:
      return action.payload.curationItemId;
    default: {
      return state;
    }
  }
}
